import { useState, useEffect } from 'react';
import { useSignInWithEmailAndPassword, useAuthState } from 'react-firebase-hooks/auth';
import {
  setPersistence,
  browserLocalPersistence,
  signInWithPopup,
} from 'firebase/auth';

import { auth, googleProvider } from '../../firebase/firebase.js'; // Update this path if needed
import { useNavigate } from 'react-router-dom';
import { logLogin } from '../../services/analytics.service';
import { getFirebaseAuthErrorMessage } from '../../helpers/firebaseAuthErrors';

import './sign-in.css'; // Ensure you have a CSS file for styling

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const [signInWithEmailAndPassword, , , hookError] = useSignInWithEmailAndPassword(auth);
  const [user, authLoading] = useAuthState(auth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Combine hook error with local error state
  const displayError = error || hookError;


  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await setPersistence(auth, browserLocalPersistence);
      const res = await signInWithEmailAndPassword(email, password);
      if (res) {
        logLogin('email');
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      await setPersistence(auth, browserLocalPersistence);
      const res = await signInWithPopup(auth, googleProvider);
      if (res) {
        logLogin('google');
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      navigate('/'); // Redirect after login
    }
  }, [user, navigate]);

  if (authLoading || user) return null;

  return (
    <div className="sign-in">
      <div className="sign-in-card">
        <h1>Bienvenido</h1>
        <p className="sign-in-subtitle">Inicia sesión en Los Portales</p>

        <form onSubmit={handleSubmit}>
          <div className="sign-in-field">
            <label htmlFor="email">Correo electrónico</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Ingresa tu correo"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="sign-in-field">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>

          <div className="sign-in-divider">
            <span>o</span>
          </div>

          <button
            type="button"
            className="google-sign-in-btn"
            onClick={handleGoogleSignIn}
            disabled={loading}
          >
            <svg className="google-icon" viewBox="0 0 24 24" width="20" height="20">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </button>

          {displayError && <p className="sign-in-error">{getFirebaseAuthErrorMessage(displayError)}</p>}
        </form>
      </div>
    </div>
  );
}
